import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is this suitable for severe back pain?",
    a: "This guide is designed for mild to moderate back pain. If you have severe or chronic pain, slipped disc, or recent injury, please consult Dr. Akshay before starting any exercises. The guide includes clear warnings for which exercises to avoid.",
  },
  {
    q: "Will I get instant download access?",
    a: "Yes! After payment, the PDF is delivered directly to your WhatsApp instantly. You can download it on any device — phone, tablet, or laptop.",
  },
  {
    q: "Is this beginner friendly?",
    a: "Absolutely. No prior fitness or yoga experience needed. Every exercise has step-by-step instructions, photos, and beginner modifications. If you can sit and stand, you can do this.",
  },
  {
    q: "Can senior citizens follow it?",
    a: "Yes. The guide includes a dedicated section with gentle modifications for seniors (60+). Many of our 5,000+ readers are above 55 and have reported great results.",
  },
  {
    q: "Is it available in Hindi?",
    a: "Yes! Each exercise and tip is explained in both Hindi and English so you can choose whichever you're more comfortable with.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 md:py-28 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">
            FAQ
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#1E3A8A] leading-tight" style={{ fontFamily: "Outfit" }}>
            Got questions?<br />
            <span className="text-emerald-600">We've got answers.</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((item, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="bg-slate-50 border border-slate-100 rounded-2xl px-5 sm:px-6 py-1 data-[state=open]:bg-white data-[state=open]:shadow-md data-[state=open]:border-slate-200 transition-all"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-[#0F172A] hover:no-underline py-5" style={{ fontFamily: "Outfit" }}>
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-sm sm:text-base leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
